const PAGE_URI_PROVIDER_ITEM_KEY = 'CURRENT_PAGE_URI';
export class UBIPageUriProvider {
    constructor(options) {
        this.storageManager = options.storageManager;
    }
    getPageUri() {
        return this.storageManager.getItem(PAGE_URI_PROVIDER_ITEM_KEY);
    }
    setPageUri(pageUri) {
        this.storageManager.setItem(PAGE_URI_PROVIDER_ITEM_KEY, pageUri);
    }
}
//# sourceMappingURL=PageUriProvider.js.map